// packages/interface/src/store/constants.js
var STORE_NAME = "core/interface";
export {
  STORE_NAME
};
//# sourceMappingURL=constants.mjs.map
